export default {"src":"/_next/static/media/safir-long.a7a776d6.svg","height":231,"width":621};